import React, { useEffect, useState, useCallback } from "react";
import { Documents } from '../../../components/Modal/components/documents-tab';
import { AssetType } from "../asset-detail-types";
import assetsApi from '../../../api/assets.api';
import { AssetDocumentType } from '../../../types/documents.type';

export default function DocumentRepository({asset, setNotification}: {readonly asset: AssetType, readonly setNotification: React.Dispatch<React.SetStateAction<any>>}) {
    const [documents, setDocuments] = useState<AssetDocumentType[]>(asset?.documents ?? []);
    const [isLoading, setIsLoading] = useState(false);

    const fetchDocuments = useCallback(async () => {
        if (!asset?.asset_id) return;
        setIsLoading(true);
        try {
            const response = await assetsApi.getSingleAsset(asset.asset_id.toString());
            setDocuments(response.data.data.documents ?? []);
        } catch (e) {
            setNotification({
                title: 'Error',
                message: 'Failed to fetch documents',
                type: 'error',
                open: true
            });
        } finally {
            setIsLoading(false);
        }
    }, [asset, setNotification]);

    useEffect(() => {
        fetchDocuments();
    }, [asset?.asset_id]);

    return (
        <div className="tab-body document-repository-container">
            <Documents documents={documents} refreshList={fetchDocuments} isLoadingFetch={isLoading} />
        </div>
    );
}